import { render, staticRenderFns } from "./ExpandPanelSimple.vue?vue&type=template&id=874151da"
import script from "./ExpandPanelSimple.vue?vue&type=script&lang=js"
export * from "./ExpandPanelSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports